import React from 'react';
import CheckCircleOutline from '@material-ui/icons/CheckCircleOutline';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

const BooleanCheck = (props) => {
  return !!props.checkResult.result ? /* @__PURE__ */ React.createElement(CheckCircleOutline, { color: "primary" }) : /* @__PURE__ */ React.createElement(ErrorOutlineIcon, { color: "error" });
};
const isBooleanCheckFailed = (checkResult) => !checkResult.result;

export { BooleanCheck, isBooleanCheckFailed };
//# sourceMappingURL=BooleanCheck.esm.js.map
